import React from 'react';
import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';

import IconOnlyButton from 'components/Buttons/IconOnlyButton';
import EventRegistrantName from '../EventRegistrantName';
import { fnRemoveGuestFromEventInCart } from '../redux/guestHelpers';

const ReviewRegistrantsForEventWaitlist = ({ sEventLookupId }) => {
  const oFormikProps = useFormikContext();
  const aGuests = oFormikProps.values.events.find(
    (event) => event.sEventLookupId === sEventLookupId
  ).guests;
  return (
    <div className='reviewRegistration__form'>
      <h4 className='reviewRegistration__listHeader t-paragraph--medium'>
        Waitlist
      </h4>
      <div className='reviewRegistration__tableWrapper'>
        <table
          className='reviewRegistration__table'
          data-cy={`event-${sEventLookupId}-waitlist-table`}
        >
          <thead className='hide_accessibly'>
            <tr>
              <th>Registrant Name</th>
              <th>Remove Registrant</th>
            </tr>
          </thead>
          <tbody className='reviewRegistration__tableBody'>
            {aGuests.map(({ sGuestLookupId, sGuestName }) => (
              <tr
                key={sGuestLookupId}
                data-cy={`registrant-${sGuestLookupId}-row`}
              >
                <td
                  className='reviewRegistration__nameCell'
                  data-cy='registrant-name'
                >
                  <EventRegistrantName sName={sGuestName} sStatus='waitlist' />
                </td>
                <td className='reviewRegistration__removeButtonCell'>
                  <IconOnlyButton
                    sIcon='minus'
                    sAriaLabel='Remove Registrant'
                    sFlavor='secondary'
                    fnHandleClick={() => {
                      fnRemoveGuestFromEventInCart(
                        sGuestLookupId,
                        sEventLookupId
                      );
                    }}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

ReviewRegistrantsForEventWaitlist.propTypes = {
  sEventLookupId: PropTypes.string.isRequired,
};

export default ReviewRegistrantsForEventWaitlist;
